import i18next from "i18next";
import lanAr from "./locale/lanAr.json";
import lanEn from "./locale/lanEn.json";
import { initReactI18next } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import "dayjs/locale/en";
import localizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import updateLocale from "dayjs/plugin/updateLocale";

// Domain-specific translations
import authEn from "./locale/domains/auth.en.json";
import authAr from "./locale/domains/auth.ar.json";
import banksEn from "./locale/domains/banks.en.json";
import banksAr from "./locale/domains/banks.ar.json";
import contractsEn from "./locale/domains/contracts.en.json";
import contractsAr from "./locale/domains/contracts.ar.json";
import customersEn from "./locale/domains/customers.en.json";
import customersAr from "./locale/domains/customers.ar.json";
import employeesEn from "./locale/domains/employees.en.json";
import employeesAr from "./locale/domains/employees.ar.json";
import entitiesEn from "./locale/domains/entities.en.json";
import entitiesAr from "./locale/domains/entities.ar.json";
import financialEn from "./locale/domains/financial.en.json";
import financialAr from "./locale/domains/financial.ar.json";
import inventoryEn from "./locale/domains/inventory.en.json";
import inventoryAr from "./locale/domains/inventory.ar.json";
import invoicesEn from "./locale/domains/invoices.en.json";
import invoicesAr from "./locale/domains/invoices.ar.json";
import maintenanceEn from "./locale/domains/maintenance.en.json";
import maintenanceAr from "./locale/domains/maintenance.ar.json";
import crmEn from "./locale/domains/crm.en.json";
import crmAr from "./locale/domains/crm.ar.json";
import propertiesEn from "./locale/domains/properties.en.json";
import propertiesAr from "./locale/domains/properties.ar.json";
import projectsEn from "./locale/domains/projects.en.json";
import projectsAr from "./locale/domains/projects.ar.json";
import profileEn from "./locale/domains/profile.en.json";
import profileAr from "./locale/domains/profile.ar.json";
import unitsEn from "./locale/domains/units.en.json";
import unitsAr from "./locale/domains/units.ar.json";
import unitInvestmentEn from "./locale/domains/unitInvestment.en.json";
import unitInvestmentAr from "./locale/domains/unitInvestment.ar.json";
import rolesEn from "./locale/domains/roles.en.json";
import rolesAr from "./locale/domains/roles.ar.json";
import sanadatEn from "./locale/domains/sanadat.en.json";
import sanadatAr from "./locale/domains/sanadat.ar.json";
import servicesEn from "./locale/domains/services.en.json";
import servicesAr from "./locale/domains/services.ar.json";
import settingsEn from "./locale/domains/settings.en.json";
import settingsAr from "./locale/domains/settings.ar.json";
import supportEn from "./locale/domains/support.en.json";
import supportAr from "./locale/domains/support.ar.json";
import taxesEn from "./locale/domains/taxes.en.json";
import taxesAr from "./locale/domains/taxes.ar.json";
import warehousesEn from "./locale/domains/warehouses.en.json";
import warehousesAr from "./locale/domains/warehouses.ar.json";
import posEn from "./locale/domains/pos.en.json";
import posAr from "./locale/domains/pos.ar.json";
import tasksEn from "./locale/domains/tasks.en.json";
import tasksAr from "./locale/domains/tasks.ar.json";
import notesEn from "./locale/domains/notes.en.json";
import notesAr from "./locale/domains/notes.ar.json";
import ordersEn from "./locale/domains/orders.en.json";
import ordersAr from "./locale/domains/orders.ar.json";
import reportsEn from "./locale/domains/reports.en.json";
import reportsAr from "./locale/domains/reports.ar.json";
import subscriptionsEn from "./locale/domains/subscriptions.en.json";
import subscriptionsAr from "./locale/domains/subscriptions.ar.json";
import promotionsEn from "./locale/domains/promotions.en.json";
import promotionsAr from "./locale/domains/promotions.ar.json";
import homeEn from "./locale/domains/home.en.json";
import homeAr from "./locale/domains/home.ar.json";
import duesEn from "./locale/domains/dues.en.json";
import duesAr from "./locale/domains/dues.ar.json";
import commonEn from "./locale/domains/common.en.json";
import commonAr from "./locale/domains/common.ar.json";
import walletEn from "./locale/domains/wallet.en.json";
import walletAr from "./locale/domains/wallet.ar.json";
import notificationsEn from "./locale/domains/notifications.en.json";
import notificationsAr from "./locale/domains/notifications.ar.json";
import stockWithdrawRequestsEn from "./locale/domains/stockWithdrawRequests.en.json";
import stockWithdrawRequestsAr from "./locale/domains/stockWithdrawRequests.ar.json";
import amerSupportEn from "./locale/domains/amerSupport.en.json";
import amerSupportAr from "./locale/domains/amerSupport.ar.json";
import actionLogsEn from "./locale/domains/actionLogs.en.json";
import actionLogsAr from "./locale/domains/actionLogs.ar.json";
import financialOverviewEn from "./locale/domains/financialOverview.en.json";
import overviewEn from "./locale/domains/overview.en.json";
import financialOverviewAr from "./locale/domains/financialOverview.ar.json";
import overviewAr from "./locale/domains/overview.ar.json";
import priceQuotationsEn from "./locale/domains/priceQuotations.en.json";
import priceQuotationsAr from "./locale/domains/priceQuotations.ar.json";
import endOfServiceEn from "./locale/domains/endOfService.en.json";
import employeeContractsEn from "./locale/domains/employeeContracts.en.json";
import custodyEn from "./locale/domains/custody.en.json";
import payrollEn from "./locale/domains/payroll.en.json";
import departmentsEn from "./locale/domains/departments.en.json";
import attendanceEn from "./locale/domains/attendance.en.json";
import leavesEn from "./locale/domains/leaves.en.json";
import employeeLoansEn from "./locale/domains/employeeLoans.en.json";
import hrReportsEn from "./locale/domains/hrReports.en.json";
import serviceContractsEn from "./locale/domains/serviceContracts.en.json";
import endOfServiceAr from "./locale/domains/endOfService.ar.json";
import employeeContractsAr from "./locale/domains/employeeContracts.ar.json";
import custodyAr from "./locale/domains/custody.ar.json";
import payrollAr from "./locale/domains/payroll.ar.json";
import departmentsAr from "./locale/domains/departments.ar.json";
import attendanceAr from "./locale/domains/attendance.ar.json";
import leavesAr from "./locale/domains/leaves.ar.json";
import employeeLoansAr from "./locale/domains/employeeLoans.ar.json";
import hrReportsAr from "./locale/domains/hrReports.ar.json";
import serviceContractsAr from "./locale/domains/serviceContracts.ar.json";
import bookingContractsEn from "./locale/domains/bookingContracts.en.json";
import bookingContractsAr from "./locale/domains/bookingContracts.ar.json";
import documentsEn from "./locale/domains/documents.en.json";
import documentsAr from "./locale/domains/documents.ar.json";
import lettersEn from "./locale/domains/letters.en.json";
import lettersAr from "./locale/domains/letters.ar.json";
import esignEn from "./locale/domains/esign.en.json";
import esignAr from "./locale/domains/esign.ar.json";
import accountingPeriodsEn from "./locale/domains/accountingPeriods.en.json";
import accountingPeriodsAr from "./locale/domains/accountingPeriods.ar.json";
import openingBalancesEn from "./locale/domains/openingBalances.en.json";
import openingBalancesAr from "./locale/domains/openingBalances.ar.json";
import recurringJournalsEn from "./locale/domains/recurringJournals.en.json";
import recurringJournalsAr from "./locale/domains/recurringJournals.ar.json";
import deferralSchedulesEn from "./locale/domains/deferralSchedules.en.json";
import deferralSchedulesAr from "./locale/domains/deferralSchedules.ar.json";
import fixedAssetsEn from "./locale/domains/fixedAssets.en.json";
import fixedAssetsAr from "./locale/domains/fixedAssets.ar.json";
import bankReconciliationsEn from "./locale/domains/bankReconciliations.en.json";
import bankReconciliationsAr from "./locale/domains/bankReconciliations.ar.json";
import provisionsEn from "./locale/domains/provisions.en.json";
import provisionsAr from "./locale/domains/provisions.ar.json";
import ejarContractsEn from "./locale/domains/ejarContracts.en.json";
import ejarContractsAr from "./locale/domains/ejarContracts.ar.json";
import announcementsEn from "./locale/domains/announcements.en.json";
import announcementsAr from "./locale/domains/announcements.ar.json";
import siteVisitBookingEn from "./locale/domains/siteVisitBooking.en.json";
import siteVisitBookingAr from "./locale/domains/siteVisitBooking.ar.json";
import appointmentBookingsEn from "./locale/domains/appointmentBookings.en.json";
import appointmentBookingsAr from "./locale/domains/appointmentBookings.ar.json";
import serviceRequestsEn from "./locale/domains/serviceRequests.en.json";
import serviceRequestsAr from "./locale/domains/serviceRequests.ar.json";
import smartReportsEn from "./locale/domains/smartReports.en.json";
import smartReportsAr from "./locale/domains/smartReports.ar.json";
import advertisementsEn from "./locale/domains/advertisements.en.json";
import advertisementsAr from "./locale/domains/advertisements.ar.json";
import breadcrumbsEn from "./locale/domains/breadcrumbs.en.json";
import breadcrumbsAr from "./locale/domains/breadcrumbs.ar.json";

// Configure dayjs plugins
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);

const savedLang = localStorage.getItem("default-lg");

// URL locale takes priority: /en/... or /ar/... overrides localStorage
const urlPathParts = window.location.pathname.split("/").filter(Boolean);
const urlLang = ["en", "ar"].includes(urlPathParts[0]) ? urlPathParts[0] : null;

const initialLang = urlLang || savedLang || "ar";

// Persist the resolved language so the rest of the app (services/general, etc.) picks it up
if (urlLang && urlLang !== savedLang) {
  localStorage.setItem("default-lg", urlLang);
}

// Merge all domain translations with the main translation files
// The main files (lanEn/lanAr) serve as the base, domain files are merged on top
const mergedEn = {
  ...lanEn,
  ...commonEn,
  ...authEn,
  ...banksEn,
  ...contractsEn,
  ...customersEn,
  ...employeesEn,
  ...entitiesEn,
  ...financialEn,
  ...inventoryEn,
  ...invoicesEn,
  ...maintenanceEn,
  ...crmEn,
  ...propertiesEn,
  ...projectsEn,
  ...profileEn,
  ...unitsEn,
  ...unitInvestmentEn,
  ...rolesEn,
  ...sanadatEn,
  ...servicesEn,
  ...settingsEn,
  ...supportEn,
  ...taxesEn,
  ...warehousesEn,
  ...posEn,
  ...tasksEn,
  ...notesEn,
  ...ordersEn,
  ...reportsEn,
  ...subscriptionsEn,
  ...promotionsEn,
  ...homeEn,
  ...duesEn,
  ...walletEn,
  ...notificationsEn,
  ...stockWithdrawRequestsEn,
  ...amerSupportEn,
  ...actionLogsEn,
  ...financialOverviewEn,
  ...overviewEn,
  ...priceQuotationsEn,
  ...endOfServiceEn,
  ...employeeContractsEn,
  ...custodyEn,
  ...payrollEn,
  ...departmentsEn,
  ...attendanceEn,
  ...leavesEn,
  ...employeeLoansEn,
  ...hrReportsEn,
  ...serviceContractsEn,
  ...bookingContractsEn,
  ...documentsEn,
  ...lettersEn,
  ...esignEn,
  ...accountingPeriodsEn,
  ...openingBalancesEn,
  ...recurringJournalsEn,
  ...deferralSchedulesEn,
  ...fixedAssetsEn,
  ...bankReconciliationsEn,
  ...provisionsEn,
  ...ejarContractsEn,
  ...announcementsEn,
  ...siteVisitBookingEn,
  ...appointmentBookingsEn,
  ...serviceRequestsEn,
  ...smartReportsEn,
  ...advertisementsEn,
  ...breadcrumbsEn,
};

const mergedAr = {
  ...lanAr,
  ...commonAr,
  ...authAr,
  ...banksAr,
  ...contractsAr,
  ...customersAr,
  ...employeesAr,
  ...entitiesAr,
  ...financialAr,
  ...inventoryAr,
  ...invoicesAr,
  ...maintenanceAr,
  ...crmAr,
  ...propertiesAr,
  ...projectsAr,
  ...profileAr,
  ...unitsAr,
  ...unitInvestmentAr,
  ...rolesAr,
  ...sanadatAr,
  ...servicesAr,
  ...settingsAr,
  ...supportAr,
  ...taxesAr,
  ...warehousesAr,
  ...posAr,
  ...tasksAr,
  ...notesAr,
  ...ordersAr,
  ...reportsAr,
  ...subscriptionsAr,
  ...promotionsAr,
  ...homeAr,
  ...duesAr,
  ...walletAr,
  ...notificationsAr,
  ...stockWithdrawRequestsAr,
  ...amerSupportAr,
  ...actionLogsAr,
  ...financialOverviewAr,
  ...overviewAr,
  ...priceQuotationsAr,
  ...endOfServiceAr,
  ...employeeContractsAr,
  ...custodyAr,
  ...payrollAr,
  ...departmentsAr,
  ...attendanceAr,
  ...leavesAr,
  ...employeeLoansAr,
  ...hrReportsAr,
  ...serviceContractsAr,
  ...bookingContractsAr,
  ...documentsAr,
  ...lettersAr,
  ...esignAr,
  ...accountingPeriodsAr,
  ...openingBalancesAr,
  ...recurringJournalsAr,
  ...deferralSchedulesAr,
  ...fixedAssetsAr,
  ...bankReconciliationsAr,
  ...provisionsAr,
  ...ejarContractsAr,
  ...announcementsAr,
  ...siteVisitBookingAr,
  ...appointmentBookingsAr,
  ...serviceRequestsAr,
  ...smartReportsAr,
  ...advertisementsAr,
  ...breadcrumbsAr,
};

const resources = {
  en: {
    translation: mergedEn,
  },
  ar: {
    translation: mergedAr,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: initialLang,
  interpolation: {
    escapeValue: false,
  },
});

// Configure Arabic locale with abbreviated weekday names to prevent overflow
// Reference: https://github.com/ant-design/ant-design/issues/54168
dayjs.updateLocale("ar", {
  weekdaysShort: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  weekdaysMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
});

// Set dayjs locale based on initial language
dayjs.locale(initialLang);

// Listen for language changes and update dayjs locale dynamically
i18next.on("languageChanged", (lng) => {
  dayjs.locale(lng);
});

export default i18next;
